import React, { useState, useCallback, useEffect } from 'react';
import { usePrevious } from "../hooks";
import { Popover, TextField, DatePicker, Icon } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';

export function DatePickerCustom(props) {

    var val = new Date(props.value);

    const [active, setActive] = useState(false);
    const [value, setValue] = useState(props.value);
    const [hasError, setHasError] = useState(false);
    const [month, setMonth] = useState(val.getMonth());
    const [year, setYear] = useState(val.getFullYear());
    const [selectedDates, setSelectedDates] = useState({ start: val, end: val });

    const prevValue = usePrevious(props.value);

    const cSharpDateToJsDate = function (val) {
        return new Date(Date.parse(val));
    }

    const formatDate = function (val) {
        const offset = val.getTimezoneOffset();
        val = new Date(val.getTime() - (offset * 60 * 1000));
        return val.toISOString().split('T')[0];
    }

    const isValidDate = function (dateString) {
        var isValid = dateString.match(/^\d{4}-\d{2}-\d{2}$/) != null;
        if (isValid) {
            var d = new Date(dateString);
            isValid = d instanceof Date && !isNaN(d);
        }

        return isValid;
    }

    const disableDatesBefore = function (val) {
        if (!val) {
            return null;
        }

        var date = cSharpDateToJsDate(val);
        date.setDate(date.getDate() - 1);
        return date;
    }

    const handlePopoverOpen = useCallback(
        () => setActive(true),
        [],
    );

    const handlePopoverClose = useCallback(
        () => setActive(false),
        [],
    );

    const handleValueChange = useCallback(
        (newValue) => {
            var val = formatDate(newValue.start);
            setActive(false);
            setValue(val);
            setSelectedDates(newValue);

            props.handleChange(props.fieldName, val);
        },
        // eslint-disable-next-line
        [],
    );

    const handleValueStringChange = useCallback(
        (newValue) => {
            setValue(newValue);
        },
        [],
    );

    const handleMonthChange = useCallback(
        (l_month, l_year) => {
            setMonth(l_month);
            setYear(l_year);
        },
        [],
    );

    const handleBlur = useCallback(
        () => {
            var l_hasError = !isValidDate(value);
            setHasError(l_hasError);

            props.handleError(props.fieldName, l_hasError);

            if (!l_hasError) {

                var l_value = value;

                if (props.fieldName === 'endDate') {

                    var startDate = cSharpDateToJsDate(props.startDate + ' ' + props.startTime);
                    var endDate = cSharpDateToJsDate(l_value + ' ' + props.endTime);
                    if (endDate < startDate) {
                        endDate.setDate(startDate.getDate() + 1);
                        l_value = formatDate(endDate);
                    }
                }

                var date = new Date(l_value);
                setValue(l_value);
                setMonth(date.getMonth());
                setYear(date.getFullYear());
                setSelectedDates({ start: date, end: date });
                
                props.handleChange(props.fieldName, l_value);
            }
        },
        // eslint-disable-next-line
        [value],
    );

    useEffect(() => {
        if (prevValue !== props.value) {
            handleValueStringChange(props.value);
        }
    });

    const activator = (
        <TextField onFocus={handlePopoverOpen}
            label={props.label}
            prefix={<Icon source={CalendarIcon} tone="subdued"></Icon>}
            placeholder="YYYY-MM-DD"
            value={value}
            onChange={(newValue) => handleValueStringChange(newValue)}
            error={hasError ? 'Match YYYY-MM-DD format' : ''}
            onBlur={handleBlur}
        />
    );

    return (
        <Popover
            active={active}
            activator={activator}
            onClose={handlePopoverClose}
        >
            <Popover.Section>
                <DatePicker
                    month={month}
                    year={year}
                    disableDatesBefore={disableDatesBefore(props.startDate)}
                    onChange={(newValue) => handleValueChange(newValue)}
                    onMonthChange={(month, year) => handleMonthChange(month, year)}
                    selected={selectedDates}
                />
            </Popover.Section>
        </Popover>
    );
}